import { render, staticRenderFns } from "./DocsAnchorTarget.vue?vue&type=template&id=3eb3ca38&scoped=true&"
import script from "./DocsAnchorTarget.vue?vue&type=script&lang=js&"
export * from "./DocsAnchorTarget.vue?vue&type=script&lang=js&"
import style0 from "./DocsAnchorTarget.vue?vue&type=style&index=0&id=3eb3ca38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb3ca38",
  null
  
)

export default component.exports